var User = /** @class */ (function () {
    function User() {
        this.isViewedprofilesActive = false;
    }
    return User;
}());
export { User };
